import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShipmentTimelineComponent } from './shipment-timeline/shipment-timeline.component';
import { MaterialModule } from '../material-module';
import { FieldparsePipe, Safe, FilterFieldparsePipe, UtcToLocalTime, FormatDateTime } from './pipe/fieldparse.pipe';
import { LoaderComponent } from './loader/loader.component';
// import { EmptyStatusComponent } from './empty-status/empty-status.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { PaginationComponent } from './pagination/pagination.component';
import { ToastComponent } from './toast/toast/toast.component';
import { BookingcancelPopupComponent } from './bookingcancel-popup/bookingcancel-popup.component';
import { SortComponent } from './sort/sort.component';
import { StComponent } from './shipment-item/st/st.component';

@NgModule({
  declarations: [
    ShipmentTimelineComponent,
    LoaderComponent,
    SortComponent, FormatDateTime,
    FieldparsePipe, Safe, FilterFieldparsePipe, EmptyStateComponent, UtcToLocalTime, PaginationComponent, ToastComponent, BookingcancelPopupComponent, SortComponent, StComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [EmptyStateComponent, ShipmentTimelineComponent,
    LoaderComponent, FieldparsePipe, Safe, FilterFieldparsePipe, UtcToLocalTime, SortComponent,
    PaginationComponent, ToastComponent, BookingcancelPopupComponent, FormatDateTime]
})
export class SharedModule { }
